import {gsap} from "../../lib/gsap";

export default class BlockJobs {
	static init() {
		let blocks = document.querySelectorAll('.block-jobs');

		blocks.forEach( (block) => {
			const swiper = block.querySelector('.swiper');
			const prev = block.querySelector(".swiper-pill-nav-prev");
			const next = block.querySelector(".swiper-pill-nav-next");

			new Swiper(swiper, {
				slidesPerView: "auto",
				grabCursor: false,
				spaceBetween: 20,
				navigation: {
					prevEl: prev,
					nextEl: next,
				}
			});
		});
	}
}
